module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// ./node_modules/readable-stream/writable-browser.js
// module id = 39
// module chunks = 1